import "core-js/modules/es.array.push.js";
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'tombac';
import { AddIcon } from 'tombac-icons';
import { CreateUserFormModal } from "./CreateUserFormModal";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreateUserButton = stylingProps => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const history = useHistory();
  const handleCancel = () => {
    setIsFormOpen(false);
  };
  const handleSaveSuccess = email => {
    setIsFormOpen(false);
    history.push(`/users/edit/${encodeURIComponent(email)}`);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      "data-testid": "create-user-button",
      onClick: () => setIsFormOpen(true),
      prepend: /*#__PURE__*/_jsx(AddIcon, {}),
      variant: "primary",
      ...stylingProps,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "CreateUserButton.tsx",
      "data-sentry-element": "Button",
      children: "New user"
    }), /*#__PURE__*/_jsx(CreateUserFormModal, {
      isOpen: isFormOpen,
      onCancel: handleCancel,
      onSaveSuccess: handleSaveSuccess,
      "data-sentry-element": "CreateUserFormModal",
      "data-sentry-source-file": "CreateUserButton.tsx",
      "data-sentry-element": "CreateUserFormModal"
    })]
  });
};